import { useBorrowerIsInvolvedInJudgements } from '../../../../../../../queries/BorrowerFields/LegalityFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface InvolvedInJudgementsProps {
    required?: boolean;
    isReview?: boolean;
}

export const InvolvedInJudgements: React.FC<InvolvedInJudgementsProps> = ({ required = false, isReview = false }) => {
    const label = 'Involved in any judgements, liens, or surety actions?';
    const [involvedInJudgements, set_involvedInJudgements] = useBorrowerIsInvolvedInJudgements();

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_involvedInJudgements(true);
                return;
            case 'no':
                set_involvedInJudgements(false);
                return;
            default:
                return;
        }
    };

    const parseDisplayValue = (value: boolean | undefined) => {
        if (value) {
            if (value == true || value == 'true') {
                return 'Yes';
            } else if (value == false || value == 'false') {
                return 'No';
            }
        }
        return '';
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={parseDisplayValue(involvedInJudgements)}
                />
            ) : (
                <YesNoToggleButton
                    id='involvedInJudgements'
                    value={involvedInJudgements}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Involved in any Judgements required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
